import "./topbar.css";

import NavLinks from "./NavLinks";
export default function Navigation(){
    
    return(
        <nav className='Navigation'>
        <NavLinks/>
        </nav>
        )}